import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-base pt-8" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-lg font-semibold leading-6 text-primary pb-2" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "p-8 relative" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-lg leading-6 text-gray-900" }
const _hoisted_13 = { class: "text-sm leading-6 text-gray-900" }
const _hoisted_14 = { class: "mt-6 flex justify-center space-x-2" }
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "mt-6 flex justify-center" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex-shrink-0" }
const _hoisted_20 = { class: "block h-5 w-5 text-green-800" }
const _hoisted_21 = { class: "min-w-0 flex-1" }
const _hoisted_22 = { class: "focus:outline-none" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute inset-0",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_24 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_25 = { class: "truncate text-sm text-gray-500" }
const _hoisted_26 = { class: "flex-shrink-0" }
const _hoisted_27 = {
  class: /*#__PURE__*/_normalizeClass(
        'flex flex-col gap-3 rounded-[20px] pb-5 '
      )
}
const _hoisted_28 = { class: "flex items-center justify-between" }
const _hoisted_29 = { class: "text-lg font-semibold leading-6 text-primary pb-2" }
const _hoisted_30 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "block h-5 w-5 text-[#008000]" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        fill: "#008000",
        d: "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
      })
    ])
  ])
], -1)
const _hoisted_32 = { class: "min-w-0 flex-1" }
const _hoisted_33 = {
  href: "#",
  class: "focus:outline-none"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute inset-0",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_35 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_36 = { class: "truncate text-sm text-gray-500" }
const _hoisted_37 = { class: "flex-shrink-0" }
const _hoisted_38 = { class: "relative px-4 pb-4 pt-5" }
const _hoisted_39 = { class: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100" }
const _hoisted_40 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_41 = { class: "text-base font-semibold leading-6 text-gray-900" }
const _hoisted_42 = { class: "mt-2" }
const _hoisted_43 = { class: "text-sm text-gray-500" }
const _hoisted_44 = { class: "mt-5 sm:mt-6" }

import {
  CloudArrowDownIcon,
  CheckIcon,
} from "@heroicons/vue/24/outline";
import { ref, computed } from "vue";
import api from "@/api";
import { useDataStore } from "@/stores/dataStore";
import { useFilterStore } from "@/stores/filterStore";
import { useUserStore } from "@/stores/userStore";
import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";
import i18n from "@/plugins/i18n";
import { DatePicker } from "v-calendar";
import "v-calendar/style.css";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportsView',
  setup(__props) {

const filterStore = useFilterStore();
const dataStore = useDataStore();
const userStore = useUserStore();

const showDownloadModal = ref(false);
const open = ref(false);

const reportsData = ref({
  "Journey Reports": [
    {
      type: "ready-for-reassessment",
      numberOfDays: 0,
      enabled: true,
      name: i18n.global.t('reports_view.reports.ready-for-reassessment.name'),
      subTitle: i18n.global.t('reports_view.reports.ready-for-reassessment.subTitle'),
    },
    {
      type: "current-levels-achieved",
      numberOfDays: 0,
      enabled: true,
      name: i18n.global.t('reports_view.reports.current-levels-achieved.name'),
      subTitle: i18n.global.t('reports_view.reports.current-levels-achieved.subTitle'),
    },
    {
      type: "incomplete-baseline-assessments",
      numberOfDays: 0,
      enabled: true,
      name: i18n.global.t('reports_view.reports.incomplete-baseline-assessments.name'),
      subTitle: i18n.global.t('reports_view.reports.incomplete-baseline-assessments.subTitle'),
    },
  ],
  "Concept Reports": [
    {
      type: "concept-mastery-achieved-per-student",
      numberOfDays: 0,
      enabled: true,
      name: i18n.global.t('reports_view.reports.concept-mastery-achieved-per-student.name'),
      subTitle: i18n.global.t('reports_view.reports.concept-mastery-achieved-per-student.subTitle'),
    },
    {
      type: "summary-of-concept-mastery",
      numberOfDays: 0,
      enabled: true,
      name: i18n.global.t('reports_view.reports.summary-of-concept-mastery.name'),
      subTitle: i18n.global.t('reports_view.reports.summary-of-concept-mastery.subTitle'),
      dateRange: true
    },
  ],
  "Activity Reports": [
    {
      type: "detailed-activity-for-last-x-days",
      days: 7,
      enabled: true,
      name: i18n.global.t('reports_view.reports.detailed-activity-for-last-7-days.name'),
      subTitle: i18n.global.t('reports_view.reports.detailed-activity-for-last-7-days.subTitle'),
    },
    {
      type: "detailed-activity-for-last-x-days",
      days: 30,
      enabled: true,
      name: i18n.global.t('reports_view.reports.detailed-activity-for-last-30-days.name'),
      subTitle: i18n.global.t('reports_view.reports.detailed-activity-for-last-30-days.subTitle'),
    },
    {
      type: "detailed-activity-for-last-x-days",
      days: 90,
      enabled: true,
      name: i18n.global.t('reports_view.reports.detailed-activity-for-last-90-days.name'),
      subTitle: i18n.global.t('reports_view.reports.detailed-activity-for-last-90-days.subTitle'),
    },
    {
      type: "inactive-for-x-days",
      enabled: true,
      days: 7,
      name: i18n.global.t('reports_view.reports.inactive-for-7-days.name'),
      subTitle: i18n.global.t('reports_view.reports.inactive-for-7-days.subTitle'),
    },
    {
      type: "inactive-for-x-days",
      enabled: true,
      days: 30,
      name: i18n.global.t('reports_view.reports.inactive-for-30-days.name'),
      subTitle: i18n.global.t('reports_view.reports.inactive-for-30-days.subTitle'),
    },
    {
      type: "inactive-for-x-days",
      enabled: true,
      days: 90,
      name: i18n.global.t('reports_view.reports.inactive-for-90-days.name'),
      subTitle: i18n.global.t('reports_view.reports.inactive-for-90-days.subTitle'),
    },
  ],
  "Graduation & Certificate Reports": [
    {
      type: "graduation",
      days: 0,
      enabled: true,
      name: i18n.global.t('reports_view.reports.graduates.name'),
      subTitle: i18n.global.t('reports_view.reports.graduates.subtitle'),
      dateRange: true
    },
    {
      type: "high-engagement",
      days: 0,
      enabled: true,
      name: i18n.global.t('reports_view.reports.high-engagement.name'),
      subTitle: i18n.global.t('reports_view.reports.high-engagement.subtitle'),
      dateRange: true
    },
    {
      type: "continued-improvement",
      days: 0,
      enabled: true,
      name: i18n.global.t('reports_view.reports.continued-improvement.name'),
      subTitle: i18n.global.t('reports_view.reports.continued-improvement.subtitle'),
      dateRange: true
    },
  ]
});

const formatCategory = (category: any) => {
  // Split the string by spaces
  const parts = category.split(" ");

  // Take the last part and convert it to lowercase
  const result = parts[parts.length - 1].toLowerCase();

  //return the result
  return result;
};

const showDownload = async (report: { type: any; days: any }) => {
  // Send report request to the server
  try {
    const payload = await dataStore.buildPayload(true, true);

    payload.reportType = report.type;
    payload.numberOfDays = report.days;

    const dateRangeReports = [
      "graduation",
      "high-engagement",
      "continued-improvement",
      "summary-of-concept-mastery"
    ];

    //set the dates for a submission specific report
    if (dateRangeReports.includes(report.type)) {
      payload.startDate = moment(startDate.value).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      payload.endDate = moment(endDate.value).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    }

    const response = await api.post("/v2/data/reports/generate", payload);

    if (response.status === 200) {
      showDownloadModal.value = true;
    } else {
      throw new Error("Failed to generate report.");
    }
  } catch (error) {
    console.error("Error generating report: ", error);
  }
};

const hideDownload = () => {
  showDownloadModal.value = false;
};

const startDate = ref(moment().startOf('year').toDate());
const endDate = ref(new Date());

const onStartDateChange = (newStartDate: Date) => {  
  startDate.value = newStartDate;
};
const onEndDateChange = (newEndDate: Date) => {
  endDate.value = newEndDate;
};
const applyDateRangeDownload = (item) => {
  showDownload(item);
  dateRangeModals.value[item.type] = false;
}

const dateRangeModals = ref({
  'summary-of-concept-mastery': false, 'graduation': false, 'high-engagement': false, 'continued-improvement': false
});
const openDateRangeModal = (type: string) => {
  dateRangeModals.value[type] = true;
};
const closeDateRangeModal = (type: string) => {
  dateRangeModals.value[type] = false;
};

const getCurrentSubjectName = computed(() => {
  const subjectName = filterStore.filterOptions?.subjects.find(
    (item: any) => item._id === filterStore.selectedFilters.subject
  );
  return subjectName?.name.toUpperCase();
});

const showPdfDownload = async () => {
  try {
    const payload = {
      subject: getCurrentSubjectName.value,
      schoolId: filterStore.selectedFilters.school,
      grade: filterStore.selectedFilters.gradeLevel
    };
    if (filterStore.selectedFilters.classGroup.length) {
      payload.class = filterStore.selectedFilters.classGroup;
    }

    const response = await api.post("/v2/data/reports/learners", payload);

    if (response.status === 200) {
      showDownloadModal.value = true;
    } else {
      throw new Error("Failed to generate pdf reports.");
    }
  } catch (error) {
    console.error("Error generating pdf reports: ", error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, {
      pageHeading: _ctx.$t('reports_view.header')
    }, null, 8, ["pageHeading"]),
    _createElementVNode("section", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportsData.value, (items, category) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([
      'flex flex-col gap-3 rounded-[20px] pb-5',
      formatCategory(category),
      (category === 'Graduation & Certificate Reports' && !_unref(userStore).isInternalAdmin) ? 'hidden' : ''
    ]),
          key: category
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(category), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400",
                onClick: ($event: any) => (!item.dateRange ? showDownload(item) : openDateRangeModal(item.type))
              }, [
                (item.dateRange)
                  ? (_openBlock(), _createBlock(_component_modal, {
                      key: 0,
                      showCloseButton: false,
                      widthClass: 'max-w-xl',
                      open: dateRangeModals.value[item.type],
                      onLocalModalOpen: ($event: any) => (dateRangeModals.value[item.type] = $event),
                      class: "no-overflow-modal"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "absolute top-4 right-4 text-gray-400 hover:text-gray-600",
                            onClick: ($event: any) => (closeDateRangeModal(item.type))
                          }, _hoisted_10, 8, _hoisted_7),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("h2", _hoisted_12, _toDisplayString(item.name), 1),
                            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t('reports_view.modal.date_range')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_unref(DatePicker), {
                              modelValue: startDate.value,
                              "onUpdate:modelValue": [
                                _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
                                onStartDateChange
                              ]
                            }, {
                              default: _withCtx(({ inputValue, inputEvents }) => [
                                _createElementVNode("input", _mergeProps({
                                  type: "text",
                                  value: inputValue
                                }, _toHandlers(inputEvents, true), {
                                  placeholder: "Start Date",
                                  class: "border border-gray-300 rounded-lg shadow-box px-2 py-1 w-[40%] focus:outline-none focus:ring-2 focus:ring-blue-500 text-base font-normal text-gray-900"
                                }), null, 16, _hoisted_15)
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createElementVNode("span", null, [
                              _createVNode(_component_rl_icon, {
                                icon: 'rl-right-arrow',
                                title: 'rl right arrow',
                                "aria-hidden": "true"
                              })
                            ]),
                            _createVNode(_unref(DatePicker), {
                              modelValue: endDate.value,
                              "onUpdate:modelValue": [
                                _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event)),
                                onEndDateChange
                              ]
                            }, {
                              default: _withCtx(({ inputValue, inputEvents }) => [
                                _createElementVNode("input", _mergeProps({
                                  type: "text",
                                  value: inputValue
                                }, _toHandlers(inputEvents, true), {
                                  placeholder: "End Date",
                                  class: "border border-gray-300 rounded-lg shadow-box px-2 py-1 w-[40%] focus:outline-none focus:ring-2 focus:ring-blue-500 text-base font-normal text-gray-900"
                                }), null, 16, _hoisted_16)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-gray-700 border border-gray-300 text-sm font-semibold px-2 py-1.5 bg-white rounded-lg flex flex-row items-center gap-1.5",
                              onClick: ($event: any) => (applyDateRangeDownload(item))
                            }, _toDisplayString(_ctx.$t('reports_view.modal.download_btn')), 9, _hoisted_18)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["open", "onLocalModalOpen"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, [
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-report-icon',
                      title: 'rl report icon',
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("p", _hoisted_24, _toDisplayString(item.name), 1),
                    _createElementVNode("p", _hoisted_25, _toDisplayString(item.subTitle), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_unref(CloudArrowDownIcon), {
                    class: "h-6 w-6 text-gray-400",
                    "aria-hidden": "true"
                  })
                ])
              ], 8, _hoisted_5))
            }), 128))
          ])
        ], 2))
      }), 128)),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.$t("reports_view.reports.pdf-bulk-download.title")), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", {
            class: "relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showPdfDownload()))
          }, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("a", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t("reports_view.reports.pdf-bulk-download.name")), 1),
                _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("reports_view.reports.pdf-bulk-download.subtitle")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_unref(CloudArrowDownIcon), {
                class: "h-6 w-6 text-gray-400",
                "aria-hidden": "true"
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: showDownloadModal.value,
      onLocalModalOpen: _cache[4] || (_cache[4] = ($event: any) => (showDownloadModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_unref(CheckIcon), {
                class: "h-6 w-6 text-green-600",
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("h3", _hoisted_41, _toDisplayString(_ctx.$t("reports_view.modal.title")), 1),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t("reports_view.modal.message")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("button", {
              type: "button",
              class: "inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (hideDownload()))
            }, _toDisplayString(_ctx.$t("reports_view.modal.button")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})